import React from 'react';
import {Card, CardVariant, CardPadding, CardRadius} from '../card';
import {Text, TextVariant, TextWeight, TextColor, HtmlTag} from '../typography/text';

export enum StatCardVariant {
  Neutral = 'neutral',
  Positive = 'positive',
  Negative = 'negative',
  Info = 'info',
}

interface StatCardProps {
  value: string | number;
  label: string;
  variant?: StatCardVariant;
  className?: string;
}

const getVariantStyles = (variant: StatCardVariant) => {
  switch (variant) {
    case StatCardVariant.Positive:
      return {
        cardVariant: CardVariant.Flat,
        containerClass: '!bg-green-50',
        valueColor: 'text-green-600',
      };
    case StatCardVariant.Negative:
      return {
        cardVariant: CardVariant.Flat,
        containerClass: '!bg-red-50',
        valueColor: 'text-red-600',
      };
    case StatCardVariant.Info:
      return {
        cardVariant: CardVariant.Flat,
        containerClass: '!bg-blue-50',
        valueColor: 'text-blue-600',
      };
    case StatCardVariant.Neutral:
    default:
      return {
        cardVariant: CardVariant.Flat,
        containerClass: '!bg-gray-50',
        valueColor: 'text-gray-900',
      };
  }
};

const StatCardComponent: React.FC<StatCardProps> = ({value, label, variant = StatCardVariant.Neutral, className = ''}) => {
  const {cardVariant, containerClass, valueColor} = getVariantStyles(variant);

  const combinedClassName = ['text-center', containerClass, className].filter(Boolean).join(' ');

  return (
    <Card variant={cardVariant} padding={CardPadding.MD} radius={CardRadius.LG} className={combinedClassName}>
      <Text variant={TextVariant.LEAD} weight={TextWeight.BOLD} className={`text-3xl mb-1 ${valueColor}`} as={HtmlTag.DIV}>
        {value}
      </Text>
      <Text variant={TextVariant.BODY_SMALL} color={TextColor.MUTED} as={HtmlTag.DIV}>
        {label}
      </Text>
    </Card>
  );
};

export const StatCard = React.memo(StatCardComponent);
